import { FC } from "react";
import { Tooltip, Button } from "@radix-ui/themes";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { GearIcon } from "@radix-ui/react-icons";
import { useNavigate } from "react-router-dom";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

interface SingleNewsAuthorActionsProps {
  createdBy: string;
  slug: string;
}

export const SingleNewsAuthorActions: FC<SingleNewsAuthorActionsProps> = ({
  createdBy,
  slug,
}) => {
  const currentUser = useCurrentUserProfile((s) => s.user);
  const navigate = useNavigate();

  const isAuthor = currentUser.uid === createdBy;
  const hasPermission = brand.hasCreate.news;

  if (!isAuthor) {
    return null;
  }

  if (!hasPermission) {
    return null;
  }

  return (
    <Tooltip content="Edit News">
      <Button
        variant="surface"
        size="3"
        onClick={() => {
          navigate(`/news/manage/${slug}`);
        }}
      >
        <GearIcon />
      </Button>
    </Tooltip>
  );
};
